import { useApp } from "../../../hooks/useApp"
import { Text } from "../../ui/Text/Text"
import { addBusinessDays, formatDate } from "./utils"

interface Props {
  className?: string
}

export const DispatchEstimate = ({ className }: Props) => {
  const { mainProduct } = useApp()

  // @Example:
  // Production Time_15 business days
  const tag = (mainProduct.tags || []).find((tag) => tag.includes('Production Time'))

  if (!tag) return null

  const currentDate = new Date()
  // get second part of productionTimeTag
  const productionTime = tag.split('_')
  // get number of productionTimeTag
  const productionTimeNumber = productionTime[1].split(' ')[0]
  const numberOfBusinessDays = Number(productionTimeNumber)
  const estimatedDispatchDate = addBusinessDays(currentDate, numberOfBusinessDays)
  const formattedDate = formatDate(estimatedDispatchDate)

  return (
    <p className={className}>
      <Text 
        className="font-calibre text-primary"
        style="label"
      >
        Estimated dispatch on {formattedDate}
      </Text>
    </p>
  ) 
}

